import { buttonClassName } from '../ui/buttonStyles';

/**
 * Padrão visual das filas da área de trabalho, igual em todos os perfis.
 *
 * Botão de linha tem duas variantes, com o mesmo formato:
 * - ACAO_LINHA_AGIR: é a sua vez (analisar, emitir parecer, vincular, dar ciência, retificar);
 * - ACAO_LINHA_CONSULTAR: só abre para ver.
 * Botão azul cheio fica reservado à ação principal da página, não a cada linha.
 *
 * Em JSX prefira `<Button variant="info" size="sm">` (agir) e `<Button variant="secondary" size="sm">`
 * (consultar); estas constantes são para elementos que não são `<button>`.
 */
export const ACAO_LINHA_AGIR = `${buttonClassName({ variant: 'info', size: 'sm' })} shrink-0 whitespace-nowrap`;

export const ACAO_LINHA_CONSULTAR = `${buttonClassName({ variant: 'secondary', size: 'sm' })} shrink-0 whitespace-nowrap`;

/** Lista plana com divisórias: evita cartão com borda dentro do cartão da seção. */
export const LISTA_DIVIDIDA = 'divide-y divide-line border-t border-line';

/** Linha clicável de uma LISTA_DIVIDIDA. */
export const LINHA_LISTA = 'flex cursor-pointer items-center justify-between gap-3 px-5 py-3 transition-colors hover:bg-surface-muted';
